import React, { useContext } from 'react'

import { NavContext } from './nav'

const NavSub = (props) => {
  const { activeSub } = useContext(NavContext)
  const [isActiveSub, setActiveSub] = activeSub

  // Add props for sub menu elements
  const childrenWithProps = React.Children.map(props.children, child => {
    return React.cloneElement(child, {
      tabIndex: '-1',
    })
  })

  return (
    <ul
      className={`${props.className}`}
      role="menu"
      aria-label={props.label}
      menu-id={props.menuid}
      aria-hidden={`${isActiveSub === props.menuid ? 'false' : 'true'}`}
    >
      {childrenWithProps}
    </ul>
  )
}
export default NavSub